









































































































































































































































































































































































































































































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {
  DistributorCommissionsModel,
  DistributorsClient,
} from "@/diamond-support-api";

@Component
export default class AssociateCommission extends Vue {
  @Getter("distributorId", { namespace: "distributor" }) distributorId: any;

  search = "";
  selectedRank: string = "";
  selectedDate: string = "";
  selectedCommPeriodId: string = "";
  loading = false;

  commissions: DistributorCommissionsModel[] | null = [];
  commissionSummary: DistributorCommissionsModel[] | null = [];
  commissions3Weeks: DistributorCommissionsModel[] | null = [];
  consecutiveRequirementWeeks: DistributorCommissionsModel[] | null = [];
  PVOptions: any[] = [];

  distributorApi = new DistributorsClient();

  headers: any[] = [
    {
      text: "PV Date",
      align: "start",
      sortable: true,
      value: "pvDate",
      class: "primary white--text",
    },
    {
      text: "Paid Rank",
      value: "paidRank",
      class: "primary white--text",
    },
    {
      text: "PV",
      value: "pv",
      class: "primary white--text",
      formatter: this.formatNumber,
    },
    {
      text: "Period LV",
      value: "periodLv",
      class: "primary white--text",
      formatter: this.formatNumber,
    },
    {
      text: "Carryover LV",
      value: "carryoverLv",
      class: "primary white--text",
      formatter: this.formatNumber,
    },
    {
      text: "Total LV",
      value: "totalLv",
      class: "primary white--text",
      formatter: this.formatNumber,
    },
    {
      text: "Period RV",
      value: "periodRv",
      class: "primary white--text",
      formatter: this.formatNumber,
    },
    {
      text: "Carryover RV",
      value: "carryoverRv",
      class: "primary white--text",
      formatter: this.formatNumber,
    },
    {
      text: "Total RV",
      value: "totalRv",
      class: "primary white--text",
      formatter: this.formatNumber,
    },
    {
      text: "PGV",
      value: "pgv",
      class: "primary white--text",
      formatter: this.formatNumber,
    },
    {
      text: "PGV3",
      value: "pgv3",
      class: "primary white--text",
      formatter: this.formatNumber,
    },
    {
      text: "Direct of 300",
      value: "directOf300",
      class: "primary white--text",
      formatter: this.formatNumber,
    },
    {
      text: "PGV-50  (Paid Rank)",
      value: "pgv50",
      class: "primary white--text",
      formatter: this.formatNumber,
    },
    {
      text: "Ambassador PGV",
      value: "ambassadorPgv",
      class: "primary white--text",
      formatter: this.formatNumber,
    },
  ];

  diamondRanks: any[] = [
    {
      id: "9",
      text: "Diamond",
    },
    {
      id: "10",
      text: "Double Diamond",
    },
    {
      id: "11",
      text: "Triple Diamond",
    },
    {
      id: "12",
      text: "Ambassador Diamond",
    },
    {
      id: "13",
      text: "Ambassador Double Diamond",
    },
    {
      id: "14",
      text: "Ambassador Triple Diamond",
    },
    {
      id: "15",
      text: "Presidential Diamond",
    },
    {
      id: "16",
      text: "Presidential Double Diamond",
    },
    {
      id: "17",
      text: "Presidential Triple Diamond",
    },
  ];

  async mounted() {
    await this.getCommissionsData(this.selectedRank, this.selectedDate);
  }

  async getCommissionsData(SelectedRank: string, SelectedDate: string) {
    this.loading = true;
    if (!SelectedRank) SelectedRank = "0";
    if (!SelectedDate) SelectedDate = "0";
    await this.distributorApi
      .getCommissions(this.$route.params.id, SelectedRank)
      .then((response: DistributorCommissionsModel[]) => {
        if (response) {
          this.loading = false;
          this.commissions = response;
          this.commissions.sort((a, b) => b.commPeriodId! - a.commPeriodId!);
          this.getCommissionSummaryData(
            this.commissions,
            SelectedRank,
            SelectedDate
          );
        }
      })
      .catch((error: any) => {
        console.log("error", error);
        this.loading = false;
      });
  }

  getCommissionSummaryData(
    commissions: DistributorCommissionsModel[],
    SelectedRank: string,
    SelectedDate: string
  ) {
    if (SelectedDate == "0") {
      var index = 0;
    } else {
      var index = commissions.findIndex((x) => x.pvDate == SelectedDate);
    }

    this.PVOptions = commissions
      .slice(0, commissions.length)
      .map((m) => m.pvDate);

    this.commissionSummary = commissions.slice(index, index + 1);
    this.commissions3Weeks = commissions.slice(index, index + 3);

    //lifetime rank as a default
    if (SelectedRank == "0") {
      this.selectedRank = this.commissionSummary[0].lifetimmeRankId!.toString();
    }
    //latest com.id as a default
    if (SelectedDate == "0") {
      this.selectedDate = this.commissionSummary[0].pvDate!;
    }
  }

  calculateCommData(commData: number, commData1: number) {
    var result =
      Math.floor((commData / commData1) * 100) > 100
        ? `100%`
        : commData1 == 0
        ? "0%"
        : `${Math.floor((commData / commData1) * 100)}%`;
    return result;
  }

  formatNumber(num: number) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  @Watch("selectedRank")
  async onSelectedRankChanged(val: string | null, oldVal: string | null) {
    if (val && !oldVal) return;
    if (val != oldVal) {
      this.commissionSummary = this.commissionSummary!.splice(
        0,
        this.commissionSummary!.length
      );
      this.getCommissionsData(this.selectedRank, this.selectedDate);
    }
  }

  @Watch("selectedDate")
  async onSelectedDateChanged(val: string | null, oldVal: string | null) {
    if (val && !oldVal) return;
    if (val != oldVal) {
      var selectedDateNew = this.selectedDate;
          this.commissionSummary = this.commissionSummary!.splice(
        0,
        this.commissionSummary!.length
      );
      selectedDateNew = this.selectedDate.toString().split(" ")[0];
      this.getCommissionsData(this.selectedRank, selectedDateNew);
    }
  }
}
